// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"EmailNotifications_btnWrapper__NuC_G","cancelBtn":"EmailNotifications_cancelBtn__1B8vc","saveBtn":"EmailNotifications_saveBtn__JkVq3"};